<ng-container [formGroup]="formGroupCampaignTypeData">
  <div class="d-flex align-items-center mat-slide-toggle__wrapper">
    <app-mdb-switch label="Ticket for Raffle" formControlName="isRaffleTicket" id="isRaffleTicket"></app-mdb-switch>
    <div class="d-flex align-items-center ml-2 h-100">
      <app-text-popover
        placement="right"
        type="content"
        text="Switch ON to enable raffle tickets for this campaign"
        title=""
      >
      </app-text-popover>
    </div>
  </div>

  <div style="padding-left: 44px;" *ngIf="formGroupCampaignTypeData.value.isRaffleTicket">
    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
      <app-mdb-switch label="Ticket for Basket Raffle" formControlName="basketRaffle" id="basketRaffle"></app-mdb-switch>
      <div class="d-flex align-items-center ml-2 h-100">
        <app-text-popover
          placement="right"
          type="content"
          text="Switch ON to convert to a Basket Raffle ticket campaign. Then add baskets or items that can be won by donors. This action is irreversible once the campaign is saved."
          title=""
        >
        </app-text-popover>
      </div>
    </div>
  </div>
  <div class="divider"></div>

  <div class="mdb-switch-wrapper">
    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
      <app-mdb-switch label="Ticket for In-Person Event" formControlName="isTicketForInPersonEvent" id="isTicketForInPersonEvent"></app-mdb-switch>
      <div *ngIf="selectedEventType === 0" class="font-weight-normal" [ngStyle]="formGroupCampaignTypeData.controls.isTicketForInPersonEvent.disabled && {'opacity': '0.3'} || null">, Connected: {{selectedEventName}}</div>
      
      <div class="d-flex align-items-center ml-2 h-100">
        <app-text-popover
          placement="right"
          type="content"
          text="Switch ON if this campaign includes tickets to attend an in person event"
          title=""
        >
        </app-text-popover>
      </div>
    </div>
  </div>
  <div class="divider"></div>

  <div class="mdb-switch-wrapper">
    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
      <app-mdb-switch label="Ticket for Virtual Event" formControlName="isTicketForVirtualEvent" id="isTicketForVirtualEvent"></app-mdb-switch>
      <div *ngIf="selectedEventType === 1 " class="font-weight-normal"  [ngStyle]="formGroupCampaignTypeData.controls.isTicketForVirtualEvent.disabled && {'opacity': '0.3'} || null">, Connected: {{selectedEventName}}</div>
      
      <div class="d-flex align-items-center ml-2 h-100">
        <app-text-popover
          placement="right"
          type="content"
          text="Switch ON if this campaign includes tickets to attend a virtual event"
          title=""
        >
        </app-text-popover>
      </div>
    </div>
  </div>

</ng-container>